import graphThree from "../../../../assets/manage_pillar_topics_organic_market_share@4x.png";

const imageStyle: React.CSSProperties = {
  width: "100%",
  zIndex: 1
};

import { Grid } from "@mui/material";

const WindowTwo = () => (
  <div>
    <Grid container direction="row" alignItems="center" justifyContent="center">
      <Grid item xs={10}>
        <img
          style={{ ...imageStyle }}
          src={graphThree}
          alt="Manage pillar topics 1st page keyword rank chart"
        />
      </Grid>
    </Grid>
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <div style={{ width: "80%", color: "white", textAlign: "center" }}>
        <h3>
          "DemandJump is the first platform I have seen that has successfully
          combined prescriptive insights with analytics... finally closing the
          loop between sales and marketing."
        </h3>
        <p style={{ marginBottom: "0px" }}>
          <small>Nate Skinner</small>
        </p>
        <p style={{ marginTop: "5px" }}>
          <small>Chief Marketing Officer at Onfido</small>
        </p>
      </div>
    </Grid>
  </div>
);

export default WindowTwo;
